<template>
    <div>
        <el-dialog title="设置成绩" :visible.sync="$store.state.user.updateScoreFlag" :close-on-click-modal="false">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="高考省份" prop="enrollProvinceId">
                            <el-select v-model="ruleForm.enrollProvinceId">
                                <el-option v-for="item, i in proviceList" :label="item.dictLabel"
                                    :value="item.dictValue" :key="i"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="高考年份" prop="enrollYear">
                            <el-select v-model="ruleForm.enrollYear">
                                <el-option v-for="item, i in yearList" :label="item" :value="item" :key="i"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="考试类型">
                        <el-radio-group v-model="ruleForm.examType">
                            <el-radio v-for="item, i in examTypeList" :label="item.dictValue" :key="i">{{
            item.dictLabel }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="高考科目">
                        <el-checkbox-group v-model="ruleForm.selectSubjectList" :min="1" :max="3">
                            <el-checkbox v-for="item, i in selectTypeList" :label="item.dictValue" :key="i">{{
            item.dictLabel }}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="高考总分">
                            <el-input v-model="ruleForm.score" type="number" @input="scoreChange">
								<i slot="suffix">
									分
								</i>
							</el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="排名位次">
                            <el-input v-model="ruleForm.rankNo"><i slot="suffix">
									位
								</i></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="marginRight15" @click='$store.commit("UPDATE_UPDATESCOREFLAG", false)'>取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { updateStudent, currentStudent,updateScore } from '@/api/login'
import { dictList } from '@/api/college'
export default {
    name: "update-info",
    data() {
        return {
            ruleForm: {
                "studentId": null,
                "userId": "",
                "enrollProvinceId": "",
                "enrollProvinceName": "",
                "enrollYear": "",
                "schoolName": "",
                "score": null,
                "rankNo": null,
                "selectSubject": "",
                "selectSubjectList": [],
                "nickName": "",
                "sex": "",
                "avatar": "",
                "phonenumber": "",
                examType:"",
            },
            rules: {
                nickName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                enrollProvinceId: [
                    { required: true, message: '请选择高考省份', trigger: 'change' }
                ],
                enrollYear: [
                    { required: true, message: '请选择高考年份', trigger: 'change' }
                ],
                sex: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ]
            },
            sexList: [],
            examTypeList:[],
            proviceList: [],
            selectTypeList: [],
            yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]

        }
    },
    created() {
        this.getDic();
        this.getStuInfo();
    },
    methods: {
        scoreChange() {
			let provinceInfo = this.proviceList.find(item => this.ruleForm.enrollProvinceId == item.dictValue)
			updateScore({
				year: this.ruleForm.enrollYear,
				clazz: '综合',
				provinceNames: provinceInfo.dictLabel,
				score: this.ruleForm.score
			}).then(res => {
				if (res && res.code == 200) {
                    this.ruleForm.rankNo = res.data
				}
			})
		},
        async getStuInfo() {
            let res = await currentStudent();
            if(res && res && res.code == 200){
                this.ruleForm = res.data
                this.$store.commit("UPDATE_STUDENT", res.data)
            }
        },
        async save() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.ruleForm.selectSubject = this.ruleForm.selectSubjectList.join(',')
                    updateStudent(this.ruleForm).then(res => {
                        if (res && res.code == 200) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.$store.commit("UPDATE_UPDATESCOREFLAG", false);
                            this.updateStu();
                        }
                    })
                }
            })
        },
        async updateStu() {
            //获取用户信息
            let user = await currentStudent();
            this.$store.commit("UPDATE_STUDENT", user.data)
        },
        async getDic() {
            //select_subject_type 选课科目字典 sys_user_sex 用户性别字典 province_type 高考地区字典
            let resSex = await dictList("sys_user_sex");
            this.sexList = resSex.data;
            let resSubjectType = await dictList("select_subject_type");
            this.selectTypeList = resSubjectType.data;
            let resProvice = await dictList("province_type");
            this.proviceList = resProvice.data;
            let resExamTypeList = await dictList("exam_type")
            this.examTypeList = resExamTypeList.data
        }

    }
}
</script>

<style lang="less"></style>